import { render, staticRenderFns } from "./PortalDecline.vue?vue&type=template&id=51225e28&lang=pug"
import script from "./PortalDecline.vue?vue&type=script&lang=js"
export * from "./PortalDecline.vue?vue&type=script&lang=js"
import style0 from "./PortalDecline.vue?vue&type=style&index=0&id=51225e28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports